import { defineStore } from 'pinia';
import { hebeClient } from '@/api/client';
import { $message } from '@nio-fe/lego';
import useGlobalStore from '@/store/globalStore';

export const useCouponStore = defineStore({
  id: 'titCoupon',
  state: () => ({
    list: [] as Record<string, any>[],
    total: '--' as number | string,
    limit: 100,
    currentPage: 1,
    creditAmount: '--' as number | string,
    dialogOpened: false,
    currentBrand: 'nio',
  }),
  actions: {
    fetchEquityInfo() {
      const {
        accountId: nioAccountId,
        alpsAccountId,
        fyAccountId,
      } = useGlobalStore().userInfo;
      const accountId = nioAccountId || alpsAccountId || fyAccountId;
      let brand = 'nio';
      if (!nioAccountId) {
        if (alpsAccountId) {
          brand = 'alps';
        } else if (fyAccountId) {
          brand = 'fy';
        }
      }
      if (!accountId) {
        this.creditAmount = '--';
        this.total = '--';
        return;
      }
      // TODO:这里的卡券数量感觉应该是获取多个品牌卡券的总数，而不是只取某个特定品牌的卡券数量，产品逻辑有待思考
      return hebeClient
        .fetchEquityInfo(accountId, brand)
        .then((data) => {
          this.creditAmount = data.credit;
          this.total = data.couponAmount;
        })
        .catch((e) => {
          $message.error('获取权益信息失败: ' + e.message);
          throw e;
        });
    },
    setDialogOpenStatus(status: boolean) {
      this.dialogOpened = status;
    },
    fetchCoupon() {
      return hebeClient
        .fetchCouponList(this.getAccountId(), this.currentBrand)
        .then((data) => {
          this.list = data.list;
        })
        .catch((e) => {
          $message.error('获取卡券失败: ' + e.message);
          this.list = [];
          throw e;
        });
    },
    getAccountId() {
      let accountId;
      const {
        accountId: nioAccountId,
        alpsAccountId,
        fyAccountId,
      } = useGlobalStore().userInfo;
      if (this.currentBrand === 'alps') {
        accountId = alpsAccountId;
      } else if (this.currentBrand === 'fy') {
        accountId = fyAccountId;
      } else {
        accountId = nioAccountId;
      }
      return accountId;
    },
    async sendCoupon(sendInfo) {
      const data = await hebeClient.createCouponTransLink(
        this.getAccountId(),
        sendInfo,
        this.currentBrand
      );
      await this.fetchCoupon();
      return data;
    },
  },
});
